import gql from 'graphql-tag';

export const CompanyHubAnnouncementBannerQuery = gql`
	query CompanyHubAnnouncementBannerQuery($pageId: ID!, $keys: [String]!) {
		confluence {
			page(id: $pageId) {
				id
				properties(keys: $keys) {
					key
					value
				}
			}
		}
	}
`;
